// extracted by mini-css-extract-plugin
export default {"Pagination":"Pagination_Pagination__COVXk","prev":"Pagination_prev__17Tys","last":"Pagination_last__9qOjr","item":"Pagination_item__e0XEL","active":"Pagination_active__YBS8e"};